export { default as TicketActionCard } from "./TicketActionCard.vue";
export { default as TicketActionField } from "./TicketActionField.vue";
export { default as TicketActionCheckbox } from "./TicketActionCheckbox.vue";
export { default as TicketActionCheckboxRow } from "./TicketActionCheckboxRow.vue";
export { default as TicketActionDropzone } from "./TicketActionDropzone.vue";
export { default as TicketActionSecondaryButton } from "./TicketActionSecondaryButton.vue";
export { default as TicketActionDialogFooter } from "./TicketActionDialogFooter.vue";

/** Shared Vuetify props for filled ticket-action controls (label goes on TicketActionField). */
export const TAD_CONTROL = {
  variant: "solo-filled",
  flat: true,
  density: "comfortable",
  color: "primary",
  hideDetails: "auto",
  class: "tad-control",
};
